export const createBoundedCache = (capacity)=>{
    const entries = new Map();
    return {
        get: (key)=>{
            const value = entries.get(key);
            if (value === undefined) {
                return undefined;
            }
            entries.delete(key);
            entries.set(key, value);
            return value;
        },
        set: (key, value)=>{
            entries.delete(key);
            entries.set(key, value);
            if (entries.size > capacity) {
                const oldestKey = entries.keys().next().value;
                if (oldestKey !== undefined) {
                    entries.delete(oldestKey);
                }
            }
        }
    };
};

//# sourceMappingURL=bounded-cache.js.map